import React, { useCallback } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { HiDotsVertical } from "react-icons/hi";

export type ChitChatMenuItem = {
  name: string;
  onClick: () => void;
};

export type ChitChatMenuProps = {
  menuItems: ChitChatMenuItem[];
};

const ChitChatMenu: React.FC<ChitChatMenuProps> = ({ menuItems }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | SVGElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = useCallback((event: React.MouseEvent<SVGElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <Box
      sx={{
        "& svg": { cursor: "pointer" },
      }}
    >
      <HiDotsVertical onClick={handleClick} size={20} />
      <Menu
        sx={{
          "& .MuiMenu-list": {
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} onClick={item.onClick}>
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default ChitChatMenu;
